var DROPDOWN_XPOS = ['center', 'left', 'right'];
var DROPDOWN_YPOS = ['top', 'bottom'];

export { DROPDOWN_XPOS, DROPDOWN_YPOS };
